"use client";
import { useState, useEffect } from "react";
import "./collage.css";

import Image from "next/image";
import useIsMobile from "@/hooks/useMobile";
import { useDictionary } from "../DictProvider/DictProvider";


interface About {
  text1: string;
  text2: string;
}

interface CollagesectionProps {
  about: About;
}

const Collagesection: React.FC<CollagesectionProps> = ({ about }) => {
  const dictionary = useDictionary();
  const mobile = useIsMobile();
  const GalleryImage = [
    {
      src: "/images/first.png",
      width: 520,
      height: 395,
    },
    {
      src: "/images/nine.png",
      width: 480,
      height: 395,
    },
    {
      src: "/images/second.png",
      width: 400,
      height: 190,
    },
    {
      src: "/images/third.png",
      width: 400,
      height: 190,
    },
    {
      src: "/images/forth.png",
      width: 400,
      height: 190,
    },
    {
      src: "/images/fifth.png",
      width: 400,
      height: 190,
    },
    {
      src: "/images/sixth.png",
      width: 400,
      height: 190,
    },
    {
      src: "/images/serventh.png",
      width: 400,
      height: 190,
    },
    {
      src: "/images/eight.png",
      width: 400,
      height: 190,
    },
  ];
  const [visibleItems, setVisibleItems] = useState<boolean>(
    mobile ? true : false
  );

  useEffect(() => {
    mobile ? setVisibleItems(false) : setVisibleItems(() => true);
  }, [mobile]);

  const showMoreItems = () => {
    setVisibleItems(!visibleItems);
  };

  return (
    <div id="about">
      <div className="grid lg:gap-x-4 grid-cols-6 lg:grid-cols-12 pt-20 pb-8 lg:p-16 px-4 md:px-12 xl:px-20  items-center ">
        <div className="col-span-12 lg:col-span-5">
          <h1 className="text-center ltr:lg:text-left rtl:text-right font-Helvetica_Neue text-3xl md:text-5xl lg:text-5xl xl:text-6xl leading-8 font-semibold text-own-black">
            {dictionary.Home.aboutTittle}
          </h1>
          <h2 className="text-center ltr:lg:text-left rtl:text-right  pt-5 pb-8 px-2 text-lg xl:text-xl">
            {dictionary.Home.aboutsubtittle}{" "}
          </h2>
          <button className="text-white  px-5 hidden  text-sm py-2 ml-7 md:ml-3 bg-primary rounded-md border-0">
            {dictionary.Home.aboutRead}
          </button>
        </div>

        <div className="col-span-12 md:col-span-7 relative pl-10 pr-10 md:pl-16 md:pr-16 lg:pr-0 font-dm_sans text-justify ">
          <span className="absolute h-full top-1/2 transform -translate-y-1/2 rtl:right-[-4rem] ltr:left-0 w-[6px] bg-primary"></span>

          <div>
            <p className="text-lg leading-[26px]">{about?.text1}</p>
            <br></br>
            {visibleItems ? (
              <p className="text-lg leading-[26px]">
              {about?.text2}
              </p>
            ) : null}
          </div>
        </div>
      </div>
      <div className="flex justify-center">
        <button
          onClick={showMoreItems}
          className="text-white block lg:hidden px-5   text-sm py-2  bg-primary rounded-md border-0"
        >
          {visibleItems
            ? dictionary?.Home?.abouteReadless
            : dictionary?.Home?.aboutRead}
        </button>
      </div>

      <div className="max-width-collage pb-40">
        <div className="flex justify-center items-center py-20">
          <hr className=" ltr:mr-3 rtl:ml-3 md:w-24 xs:w-16 w-12 border-t-4  xs:border-t-8 border-primary" />
          <span className="md:text-[42px] text-[26px] text-center font-bold font-Helvetica_Neue">
            {dictionary?.Home?.socialgallery}
          </span>
          <hr className=" ltr:ml-3 rtl:mr-3 md:w-24 xs:w-16 w-12 border-t-4  xs:border-t-8 border-primary" />
        </div>

        <div className="angry-grid">
          {GalleryImage?.map((item, index) => (
            <div id={`item-${index}`} key={index}>
              {" "}
              <Image
                className="img-ratio"
                src={item.src}
                alt={`college-${index}`}
                width={item.width}
                height={item.height}
                quality={50} // Lower quality for faster loading
                priority={true}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Collagesection;
